























import { Vue, Component, PropSync, Prop } from "vue-property-decorator";
import { ApkDetectionLogItem } from "./apk.interface";
import { ApkService } from "./apk.service";
@Component
export default class ApkDetectionLogsDialog extends Vue {
  visible = false;
  loading = 0;
  source: ApkDetectionLogItem[] = [];

  tabIndex = "0";

  get curTabInfo() {
    return this.source[this.tabIndex];
  }

  async open(detectionId: string) {
    this.tabIndex = "0";
    this.visible = true;
    this.loading++;
    if (this.$route.query.type === "log") {
      this.source = await ApkService.getApkDetectionApkLogs(detectionId);
    } else {
      this.source = await ApkService.getApkDetectionLogs(detectionId);
    }
    this.loading--;
  }
}
